module.exports = __webpack_public_path__ + "static/media/2nd_banner_item1.5cc9e4a8.webp";